<template>
  <FormItem :label="inputInfo?.title" :prop="setProp()" :rules="setRules()">
    <template #label>
      {{ inputInfo?.title }}
      <span
        v-if="inputInfo.titleOther"
        class="other"
        v-html="inputInfo.titleOther"
      ></span>
    </template>

    <Input
      v-if="inputInfo.type == 'input'"
      v-model="inputInfo.value"
      :placeholder="inputInfo.placeholder || `请输入${inputInfo.title}`"
      :disabled="inputInfo.disabled"
      clearable
      @on-change="inputInfo.change || null"
      :maxlength="inputInfo.maxlength"
      @on-keyup.enter="nextInput"
      :show-word-limit="inputInfo.maxlength ? true : false"
    ></Input>

    <Input
      v-else-if="inputInfo.type == 'password'"
      v-model="inputInfo.value"
      type="password"
      :placeholder="inputInfo.placeholder || `请输入${inputInfo.title}`"
      autocomplete="off"
      clearable
      :disabled="inputInfo.disabled"
      @on-change="inputInfo.change || null"
      :maxlength="inputInfo.maxlength"
      @on-keyup.enter="nextInput"
    ></Input>

    <Input
      :disabled="inputInfo.disabled"
      v-else-if="inputInfo.type == 'textarea'"
      type="textarea"
      v-model="inputInfo.value"
      :placeholder="inputInfo.placeholder || `请输入${inputInfo.title}`"
      clearable
      @on-change="inputInfo.change || null"
      :maxlength="inputInfo.maxlength"
      :show-word-limit="inputInfo.maxlength ? true : false"
      v-bind="inputInfo.props"
    ></Input>

    <Input
      v-else-if="inputInfo.type == 'number'"
      type="number"
      v-model="inputInfo.value"
      :placeholder="inputInfo.placeholder || `请输入${inputInfo.title}`"
      clearable
      :disabled="inputInfo.disabled"
      @on-change="inputInfo.change || null"
      @on-keyup.enter="nextInput"
    ></Input>

    <DatePicker
      v-if="
        [
          'date',
          'daterange',
          'datetime',
          'datetimerange',
          'year',
          'month',
        ].includes(inputInfo.type)
      "
      v-model="inputInfo.value"
      :type="inputInfo.type"
      placement="bottom-end"
      placeholder="请选择"
      :disabled="inputInfo.disabled"
      clearable
      @on-change="inputChange($event)"
      :disabled-date="inputInfo.disabledDate"
      @on-keyup.enter="nextInput"
      v-bind="inputInfo.props"
    ></DatePicker>

    <Select
      v-else-if="['select'].includes(inputInfo.type)"
      v-model="inputInfo.value"
      :multiple="inputInfo.multiple"
      :placeholder="inputInfo.placeholder || `请选择${inputInfo.title}`"
      :disabled="inputInfo.disabled"
      clearable
      filterable
      filter-by-label
      @on-change="inputChange($event)"
      @on-keyup.enter="nextInput"
      v-bind="inputInfo.props"
    >
      <!-- 
        default-first-option
      :filter-method="filterMethod" -->
      <Option
        v-for="item in inputInfo.option"
        :key="item.value"
        :value="item.value"
        :label="item.labelAndPinyi || item.label"
        >{{ item.label }}</Option
      >
    </Select>

    <Cascader
      v-else-if="inputInfo.type == 'cascader'"
      v-model="inputInfo.value"
      :disabled="inputInfo.disabled"
      clearable
      :options="inputInfo.option"
      :props="inputInfo.props || { expandTrigger: 'hover' }"
      @on-change="inputChange($event)"
      @on-keyup.enter="nextInput"
      filterable
    />
    <RadioGroup
      v-else-if="inputInfo.type == 'radio'"
      v-model="inputInfo.value"
      :disabled="inputInfo.disabled"
      @on-change="inputChange($event)"
    >
      <Radio
        v-for="item in inputInfo.option"
        :label="item.value"
        :value="item.value"
        :key="item.value"
        >{{ item.label }}</Radio
      >
    </RadioGroup>
    <!-- <icon-select
      v-else-if="inputInfo.type == 'iconselect'"
      v-model="inputInfo.value"
      @on-change="inputChange($event)"
    /> -->

    <CheckboxGroup
      v-else-if="inputInfo.type == 'checkbox'"
      v-model="inputInfo.value"
      @on-change="inputChange($event)"
    >
      <Checkbox
        v-for="item in inputInfo.option"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </Checkbox>
    </CheckboxGroup>

    <component
      v-else-if="inputInfo.type == 'component'"
      :is="inputInfo.component || ''"
      v-model="inputInfo.value"
      @on-change="inputChange($event)"
      @on-keyup.enter="nextInput"
      v-bind="inputInfo.props"
    />

    <!-- 树状选择组件 -->
    <!-- 
    <div v-if="inputInfo.type === 'treeSelect'" style="width: 100%">
      <treeSelectRadio
        v-model="inputInfo.value"
        :options="inputInfo.option"
      ></treeSelectRadio>
    </div>

    <el-autocomplete
      :disabled="inputInfo.disabled"
      v-else-if="inputInfo.type == 'autocomplete'"
      v-model="inputInfo.value"
      :placeholder="inputInfo.placeholder || `请输入${inputInfo.title}`"
      clearable
      @on-change="inputInfo.change || null"
      v-bind="inputInfo.props"
      :maxlength="inputInfo.maxlength"
      :show-word-limit="inputInfo.maxlength ? true : false"
    ></el-autocomplete>
    <uploadPic
      v-else-if="['uploadPic'].includes(inputInfo.type)"
      v-model="inputInfo.value"
      :multiple="inputInfo.multiple"
      :placeholder="inputInfo.placeholder || `请上传${inputInfo.title}`"
      :disabled="inputInfo.disabled"
      v-bind="inputInfo.props"
    /> -->
  </FormItem>
</template>

<script>
export default {
  props: {
    inputInfo: {
      type: Object,
      default: () => ({
        value: "",
        title: "",
        type: "",
        field: "",
        change: () => {},
        option: [],
      }),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {},
  data() {
    return {
      keyword: "",
    };
  },
  methods: {
    inputChange(val) {
      this.inputInfo.change && this.inputInfo.change(val);
      if (!this.inputInfo.multiple) focus();
    },
    focus() {},
    filterMethod(value) {
      this.keyword = value;
    },
    getPrevElement(el) {
      el = el.parentNode;
      if (el && el.className) {
        el = el.className.indexOf("el-col") > -1 ? el : this.getPrevElement(el);
        return el;
      } else {
        return null;
      }
    },
    nextInput(e) {
      let el = this.getNextElement(e.target);
      while (this.getPrevElement(el)?.style.display == "none") {
        el = this.getNextElement(el);
      }
      el.focus();
    },
    getNextElement(field) {
      var form = field.form;
      for (var e = 0; e < form.elements.length; e++) {
        if (field == form.elements[e]) break;
      }
      return form.elements[++e % form.elements.length];
    },
    setRules() {
      let obj = {};
      let obj2 = {};
      let i = this.inputInfo;
      if (i.isHide) return null;

      if (i.required) {
        obj = { required: true, trigger: "change" };
        switch (i.type) {
          case "datetime":
          case "date":
            {
              obj["message"] = "请选择" + i.title;
              obj["type"] = "date";
            }
            break;
          case "select":
          case "radio":
            obj["message"] = "请选择" + i.title;
            break;
          case "autocomplete":
          case "component":
          case "password":
          case "number":
          case "textarea":
          case "input":
            {
              obj["message"] = "请输入" + i.title;
              obj["trigger"] = "blur";
              obj2 = this.common.clone(obj);
              obj2.validator = this.checkEmpty;
            }
            break;
          case "checkbox":
          case "cascader":
          case "areaselect":
            {
              obj["message"] = "请选择" + i.title;
              obj["type"] = "array";
            }
            break;
          case "uploadPic":
            {
              obj["message"] = "请上传" + i.title;
            }
            break;
        }
      }
      switch (i.type) {
        case "textarea":
        case "input":
          {
            let arr = [obj, obj2];
            return i.rules ? [...arr, ...i.rules] : arr;
          }
          break;

        default:
          return i.rules ? [obj, ...i.rules] : [obj];
          break;
      }
    },
    setProp() {
      return `list.${this.index}.value`;
    },
    checkEmpty(rule, value, callback) {
      if (/^\s+$/.test(value)) {
        return callback(new Error(rule.message));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.other {
  color: #999;
  font-weight: normal;
}
.ivu-form-item {
  :deep {
    .ivu-input[disabled] {
      color: #666;
    }
  }
}
</style>